import React from 'react';

import { AddCardLayout } from './AddCardLayout';
import { AddCard } from './AddCard';
import { useAddCardController } from './hooks/useAddCardController';

export interface IAddCardControllerProps {
  onCardAdded?(params: { paymentInstrumentId: string | null }): void;
}

export const AddCardController: React.FC<IAddCardControllerProps> = (props) => {
  const { onCardAdded } = props;
  const { loading, cardholderName, handleSubmit } = useAddCardController({ onCardAdded });

  return (
    <AddCardLayout loading={loading}>
      <AddCard cardholderName={cardholderName} onSubmit={handleSubmit} />
    </AddCardLayout>
  );
};
